<template>
    <div class="container login-container">
        <div class="row">
            <div class="col-12 col-md-6 offset-0 offset-md-3 text-center my-4">
                <img class="login-logo" src="../../assets/image/BisericaBaptistaSperanta-Logo.png" alt="Biserica Baptista Speranta">
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 offset-0 offset-md-3 login-form-1">
                <h3>Login</h3>
                <form>
                    <div class="form-group">
                        <input type="text" v-model="username" class="form-control" placeholder="Your Username *" value="" />
                    </div>
                    <div class="form-group">
                        <input type="password" v-model="password" class="form-control" placeholder="Your Password *" value="" />
                    </div>
                    <div class="form-group">
                        <input type="submit" @click.prevent="onLogin" class="btnSubmit" value="Login" />
                    </div>
                    <div class="form-group">
                        <!-- <a href="#" class="ForgetPwd">Forget Password?</a> -->
                    </div>
                </form>
                <div class="row d-flex justify-content-center">
                    <div class="submit-error mt-3">{{ errMessage }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { mapActions } from 'vuex';
  export default {
    data() {      
       return {
            username: "",            
            password: "",
            errMessage: ""
        };        
    },
    methods: {
        onLogin() {
            const formData = {
                username: this.username,
                password: this.password
            };                                                                      
            this.$store.dispatch("auth/authRequest", formData).then(() => {
                this.$router.push("/");                
            }).catch((error) => {
                console.log(error.response);
                if (error.response.data.message) {
                    this.errMessage = error.response.data.message;
                    console.log(this.errMessage);
                } else {
                    this.errMessage = error.response.statusText;
                }
            });            
        }
    },
  }
</script>
<style lang="scss">
    .login-form-1 {
        padding: 5%;
        box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 9px 26px 0 rgba(0, 0, 0, 0.19);
        h3 {
            text-align: center;
            color: #333;
        }
        .btnSubmit{
            font-weight: 600;
            color: #fff;
            background-color: #0062cc;
        }
    }       
    .submit-error {
        color: red;
        font-size: 20px;
    }
    .login-logo {
        max-width: 300px;
    }

</style>


// WEBPACK FOOTER //
// src/components/auth/Login.vue